export const CHECKOUT_SETUP_MOVE_STEP = "checkout/setup-move-step";
export const CLOSE_TOPUP = "checkout/close-topup";
